<template>
  <div class="v-collapse">
    <a class="v-collapse-toggler" href="javascript:void(0)" :class="{open: show}" @click="show = !show">{{title}}</a>
    <u-collapse v-model="show">
      <slot></slot>
    </u-collapse>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      show: this.value
    }
  },
  watch: {
    value: function (v) {
      this.show = v
    },
    show: function (v) {
      this.$emit('input', v)
    }
  }
}
</script>
<style lang="scss">
.v-collapse {
  border-radius: 5px;
  border: 1px solid #bfc4c8;

  .v-collapse-toggler {
    display: block;
    position: relative;
    padding: 15px 20px;
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    background: #f29b4f;
    transition: all 0.2s ease;

    &:focus,
    &:hover,
    &:active,
    &:visited {
      color: #fff;
    }

    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 50%;
      right: 20px;
      width: 0.45em;
      height: 0.45em;
      vertical-align: middle;
      margin-top: -8px;
      border-style: solid;
      border-width: 0.22em 0.22em 0 0;
      color: white;
      font-size: 12px;
      box-sizing: content-box;
      transform: rotate(135deg);
    }

    &.open {
      background: #fff1ee;
      border-radius: 5px 5px 0 0;
      color: #333;

      &:after {
        color: #333;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collapse/Collapse.vue